import { Dispatch, memo, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import { WarehousePermitWorker } from "../../../constants/common";
import Accordion from "../../../components/accordian";
import AccompanyingPersonnelDetailsGroupCard from "../../../components/card/AccompanyingPersonnelDetailsGroupCard";
import AccompanyingPersonnelGroupTable from "../../../components/table/AccompanyingPersonnelGroupTable";
import { Plus } from "lucide-react";
import { Button } from "../../../components/button";

interface VisitorsGroupProps {
  addedWorkers: WarehousePermitWorker[];
  setAddedWorkers: Dispatch<SetStateAction<WarehousePermitWorker[]>>;

  isVipDelegations?: boolean;

  isFieldsDisabled: boolean;
}

const AccompanyingPersonnelDetails = ({
  addedWorkers,
  setAddedWorkers,

  isFieldsDisabled,
}: VisitorsGroupProps) => {
  const [isAddVisitorFormVisible, setIsAddVisitorFormVisible] =
    useState<boolean>(true);

  const [selectedKey, setSelectedKey] = useState<string>("1");

  const { t } = useTranslation();

  const [editingWorker, setEditingWorker] =
    useState<WarehousePermitWorker | null>(null);

  const handleFormReset = () => {
    setEditingWorker(null);
  };

  return (
    <div className="z-50 bg-white p-2 md:p-4 rounded-xl flex flex-col gap-3 lg:gap-6 shadow-[0px_1px_5px_0px_rgba(113,112,163,0.3)]">
      <Accordion
        id="1"
        selectedKey={selectedKey}
        onSelectionChange={setSelectedKey}
        title={
          <h1 className="text-xl md:text-2xl flex flex-1 -mt-2 items-center">
            {t("2")}. {t("accompanyingPersonnelDetails")}
          </h1>
        }
      >
        <div className="flex flex-col gap-2">
          <div className="grid md:flex md:justify-end gap-1">
            {!isFieldsDisabled && (
              <Button
                type="button"
                onClick={() => {
                  setIsAddVisitorFormVisible(false);
                  setEditingWorker(null);

                  setTimeout(() => {
                    setIsAddVisitorFormVisible(true);
                  }, 0);
                }}
                Icon={<Plus size={20} />}
              >
                {t("addWorker")}
              </Button>
            )}
          </div>

          <AccompanyingPersonnelGroupTable
            addedWorkers={addedWorkers}
            setAddedWorkers={setAddedWorkers}
            setEditingWorker={setEditingWorker}
            setIsAddVisitorFormVisible={setIsAddVisitorFormVisible}
            onFormReset={handleFormReset}
            isFieldsDisabled={isFieldsDisabled}
          />

          {isAddVisitorFormVisible && (
            <AccompanyingPersonnelDetailsGroupCard
              setIsAddVisitorFormVisible={setIsAddVisitorFormVisible}
              addedWorkers={addedWorkers}
              setAddedWorkers={setAddedWorkers}
              editingWorker={editingWorker}
              setEditingWorker={setEditingWorker}
              isFieldsDisabled={isFieldsDisabled}
            />
          )}
        </div>
      </Accordion>
    </div>
  );
};

export default memo(AccompanyingPersonnelDetails);
